import React, { useContext } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { List, ListItem, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { gray } from 'src/templates/shared-theme/themePrimitives';
import { Card, CardContainer } from 'src/components/CardContainer';
import { AppContext } from 'src/AppContext';
import { userMe, userCreate, setSessionToken } from 'src/api/api';

export default function CreateUser() {
  const { setUser } = useContext(AppContext);
  const navigate = useNavigate();
  const [createUserError, setCreateUserError] = React.useState(false);
  const [createUserErrorMessage, setCreateUserErrorMessage] = React.useState('');

  const queryParams = new URLSearchParams(window.location.search);
  const promptID = queryParams.get('promptID');
  if (!promptID) {
    return <Navigate to="/" replace />;
  }

  const resetError = () => {
    setCreateUserError(false);
    setCreateUserErrorMessage('');
  }

  const onCreateUser = async () => {
    const userNameInput = document.getElementById('userName');
    const userName = userNameInput.value;
    const agreementInput = document.getElementById('agreement');

    if (userName.length == 0) {
      setCreateUserError(true);
      setCreateUserErrorMessage('User name cannot be empty');
      return;
    }

    if (!agreementInput.checked) {
      setCreateUserError(true);
      setCreateUserErrorMessage('Please accept the agreements');
      return;
    }
    
    const resp = await userCreate(promptID, userName);
    if (resp.error) {
      setCreateUserError(true);
      setCreateUserErrorMessage(resp.message);
      return;
    }

    // save session
    setSessionToken(resp.sessionToken);
    // fetch user
    const user = await userMe();
    if (user.error) {
      setCreateUserError(true);
      setCreateUserErrorMessage(user.message);
      return;
    }
    // add user to context and jump home
    setUser(user);
    navigate("/");
  }

  return (
    <CardContainer direction="column" justifyContent="space-between">
      <Card variant="outlined">
        <Typography
          component="h1"
          variant="h4"
          sx={{ width: '100%', fontSize: 'clamp(2rem)' }}
        >
          What's Your Name?
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            gap: 2,
          }}
        >
          <FormControl>
            <TextField
              error={createUserError}
              helperText={createUserErrorMessage}
              id="userName"
              type="text"
              name="userName"
              placeholder="Name"
              autoComplete="userName"
              autoFocus
              required
              fullWidth
              variant="outlined"
              color={createUserError ? 'error' : 'primary'}
              onChange={resetError}
            />
          </FormControl>
          <Stack direction="column">
            <FormControlLabel
              control={<Checkbox id="agreement" name="agreement" value="" color="primary" />}
              label="I confirm that I have read and agree to:"
              onChange={resetError}
            />
            <List sx={{padding: 0, ml: 2}}>
              <ListItem><Link href="/terms-and-conditions.html" target="_blank">Terms and Conditions</Link></ListItem>
              <ListItem><Link href="/privacy-policy.html" target="_blank">Privacy Policy</Link></ListItem>
            </List>
          </Stack>
          <Button
            fullWidth
            variant="contained"
            color="secondary"
            onClick={onCreateUser}
          >
            Create User
          </Button>
        </Box>

      </Card>
    </CardContainer>
  )
}